import { css } from '@styled-system/css'
import styledComponents from 'styled-components'
import { Flex } from 'ui/acro'

const SortToggleFlexBox = styledComponents(Flex)`
${css({
  justifyContent: 'space-between',
  alignItems: ['start', 'center', 'center', 'center'],
  gap: ['11px', null, null, null],
  pb: '17px',
  mt: '17px'
})}
`

export default SortToggleFlexBox
